import React from 'react'
import DiscordSVG from '../../../assets/images/discord.svg'
import FacebookSVG from '../../../assets/images/facebook.svg'
import TwitterBlackSVG from '../../../assets/images/twitter_black.svg'

import './footer.scss'

const Footer = () => {

    return (
        <div className="footer-wrapper">
            <div className="footer-content">
                <div className="footer-info">
                    {/* <span>Imprint</span>
                    <span>Privacy</span> */}
                </div>

                <div className="footer-credits">
                    © 2022 hashrate Studios. All rights reserved
                </div>

                <div className="footer-socials">
                    <a
                        target="_blank"
                        href="https://discord.com/invite/7ycuZFGz">
                        <img src={DiscordSVG} />
                    </a>
                    <a
                        target="_blank"
                        href="https://twitter.com/intent/follow?original_referer=https%3A%2F%2Fhashrate-studios.webflow.io%2F&ref_src=twsrc%5Etfw%7Ctwcamp%5Ebuttonembed%7Ctwterm%5Efollow%7Ctwgr%5EhashrateStudios&region=follow_link&screen_name=hashrateStudios"
                    >
                        <img src={TwitterBlackSVG} />
                    </a>
                </div>
            </div>
        </div>
    )
}

export default Footer